export default __webpack_public_path__ + "static/media/pixIcon.7ab75da9.svg";